(() => {
  function init(root) {
    root.querySelectorAll('.art-memorials').forEach(section => {
      const button = section.querySelector('.art-memorials__zoom');
      const dialog = section.querySelector('dialog');
      if (!button || !dialog || button.dataset.zoomReady) return;
      button.dataset.zoomReady = 'true';
      button.addEventListener('click', () => {
        const image = button.querySelector('img').cloneNode(true);
        image.removeAttribute('loading');
        dialog.querySelector('[data-memorial-preview]').replaceChildren(image);
        dialog.showModal();
      });
      dialog.querySelector('.art-memorials__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
